import { render, staticRenderFns } from "./ResourceAdmin.vue?vue&type=template&id=78b474ff&scoped=true"
import script from "./ResourceAdmin.vue?vue&type=script&lang=js"
export * from "./ResourceAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b474ff",
  null
  
)

export default component.exports